import { bins } from '../interfaces/GameScreen'
import TrashBin from './TrashBin'

export function Truck() {
	return (
		<>
			<div className="-bottom-10 pointer-events-none absolute left-5 z-10 lg:bottom-20 lg:left-28 lg:scale-150">
				<img
					src="./assets/caminhao/carroceria.svg"
					alt="Caminhão de Reciclagem"
					className="relative z-10 size-80 lg:size-96"
				/>

				<img
					src="./assets/caminhao/roda.svg"
					alt="Roda"
					className="absolute bottom-12 left-10 z-20 size-14 animate-spin lg:bottom-16 lg:left-14 lg:size-16"
					style={{ animationDuration: '1s' }}
				/>
				<img
					src="./assets/caminhao/roda.svg"
					alt="Roda"
					className="absolute bottom-12 left-28 z-20 size-14 animate-spin lg:bottom-16 lg:left-36 lg:size-16"
					style={{ animationDuration: '1s' }}
				/>
				<img
					src="./assets/caminhao/roda.svg"
					alt="Roda"
					className="absolute right-9 bottom-12 z-20 size-14 animate-spin lg:right-11 lg:bottom-16 lg:size-16"
					style={{ animationDuration: '1s' }}
				/>
			</div>

			<div className="absolute bottom-20 left-4 z-30 flex lg:bottom-44 lg:left-8">
				{bins.map((bin) => (
					<TrashBin key={bin.id} {...bin} />
				))}
			</div>
		</>
	)
}
